import { render, staticRenderFns } from "./DyorLogo.vue?vue&type=template&id=4d7e0d6e&scoped=true"
import script from "./DyorLogo.vue?vue&type=script&lang=js"
export * from "./DyorLogo.vue?vue&type=script&lang=js"
import style0 from "./DyorLogo.vue?vue&type=style&index=0&id=4d7e0d6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7e0d6e",
  null
  
)

export default component.exports